export default __webpack_public_path__ + "static/media/ic_uni_40.02be34a3.svg";